import { combineReducers } from 'redux';
import alert from './alert';
import metadata from './metadata';
import patient from './patient';
import file from './file';
import user from './user';
import invitation from './invitation';
import log from './log';
import testimonial from './testimonial';
import channel from './channel';
import websocket from './websocket';
import fpp from './fpp';
import team from './team';

const rootReducer = combineReducers({
  alert,
  user,
  metadata,
  patient,
  file,
  invitation,
  log,
  testimonial,
  channel,
  websocket,
  fpp,
  team,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js